<script lang="ts">
    import {getLocalization} from 'core/svelte-context/context';
    import {createEventDispatcher} from 'svelte';
    import KpStyledSelect from 'shared/ui-widgets/select/KpStyledSelect.svelte';

    export let currentSize: number;
    export let availableSizes: number[];

    const dispatch = createEventDispatcher<{'change-page-size': number}>();
    const localize = getLocalization();

    function changePageSize() {
        dispatch('change-page-size', currentSize);
    }
</script>

<span class="search-page-size-selector">
    <label for="search-page-size-select">{localize(/* @kp-localization vysledky.zaznamuNaStranku */  'vysledky.zaznamuNaStranku')}:</label>

    <KpStyledSelect id="search-page-size-select" bind:value={currentSize} on:change={changePageSize}>
        {#each availableSizes as size}
			<option value={size}>
				{size}
			</option>
		{/each}
    </KpStyledSelect>
</span>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .search-page-size-selector {
        display: inline-flex;
        align-items: center;
        gap: @spacing-s;

        label {
            margin-bottom: 0;
        }
    }
</style>